import React from 'react';
import {
    Input,
    TextField,
    withStyles,
    InputLabel,
    InputAdornment,
    IconButton,
    FormLabel,
    FormControl,
    FormHelperText,
} from '@material-ui/core';


const inputStyle = {
    fontFamily: 'Muli',
    fontSize: window.screen.width < 770 ? 12 : 14,
    fontWeight: 400,
    color: '#000 !important',
};
const labelStyle = {
    fontFamily: 'Muli',
    fontSize: window.screen.width < 770 ? 12 : 14,
    fontWeight: 400,
};

const styles = () => ({
    cssUnderline: {
        '&:after': {
            borderBottomColor: '#027AFF',
        },
    },
    cssUnderlineRed: {
        '&:after': {
            borderBottomColor: '#FF1E59',
        },
        '&:before': {
            borderBottomColor: '#FF1E59',
        },
        '&:hover': {
            borderBottomColor: '#FF1E59',
        },
    },
    cssFocused: {},
    cssLabel: {
        '&$cssFocused': {
            color: '#027AFF',
        },
    },
});

const adornmentInputField = props => {
    const { classes, style, danger, ...other } = props;
    let newStyle = inputStyle;
    let readOnly_Flag = true;
    if (style) {
        newStyle = { ...style, ...inputStyle };
    }
    return (
        <Input
            classes={{
                underline: danger ? classes.cssUnderlineRed : classes.cssUnderline,
                ...classes,
            }}
            readOnly={readOnly_Flag}
            autoFocus={props.autoFocus}
            style={newStyle}
            endAdornment={
                <InputAdornment position="end" style={{ padding: 0 }}>
                    <IconButton onClick={props.onClick} style={{ padding: 0 }}>
                        {props.children}
                    </IconButton>
                </InputAdornment>
            }
            {...other}
        />
    );
};

const CustomAdornmentInput = withStyles(styles)(adornmentInputField);

const InputField = props => {
    const { classes, style, danger, ...other } = props;
    let newStyle = inputStyle;
    if (style) {
        newStyle = { ...style, ...inputStyle };
    }
    return (
        <Input
            classes={{
                underline: danger ? classes.cssUnderlineRed : classes.cssUnderline,
                ...classes,
            }}
            style={newStyle}
            inputProps={!other.inputProps ? { style: { fontSize: 14 } } : {}}
            {...other}
        />
    );
};

const CustomInput = () => withStyles(styles)(InputField);

const TextInputField = props => {
    const { InputLabelProps, InputProps, ...other } = props;
    let classes = {
        underline: props.classes.cssUnderline,
    };
    let labelClasses = {
        root: props.classes.cssLabel,
        focused: props.classes.cssFocused,
    };
    if (InputProps && InputProps.classes) {
        classes = {
            underline: props.classes.cssUnderline,
            ...InputProps.classes,
        };
    }
    let newInputStyle = inputStyle;
    if (InputProps && InputProps.style) {
        newInputStyle = { ...inputStyle, ...InputProps.style };
    }
    let newInputLabelStyle = labelStyle;
    if (InputLabelProps && InputLabelProps.style) {
        newInputLabelStyle = { ...newInputLabelStyle, ...InputLabelProps.style };
    }
    if (InputLabelProps && InputLabelProps.classes) {
        labelClasses = {
            root: props.classes.cssLabel,
            focused: props.classes.cssFocused,
            ...InputLabelProps.classes,
        };
    }
    return (
        <TextField
            InputProps={{
                classes,
                style: newInputStyle,
                ...InputProps,
            }}
            InputLabelProps={{
                style: newInputLabelStyle,
                classes: labelClasses,
                ...InputLabelProps,
            }}
            {...other}
        />
    );
};

const CustomTextField = withStyles(styles)(TextInputField);

const Label = props => {
    const { classes, style, ...other } = props;
    let newStyle = labelStyle;
    if (style) {
        newStyle = { ...style, ...labelStyle };
    }
    return (
        <InputLabel
            style={newStyle}
            classes={{
                root: classes.cssLabel,
                focused: classes.cssFocused,
                ...classes,
            }}
            {...other}
        />
    );
};

const CustomInputLabel = withStyles(styles)(Label);



const newStyles = {
    searchInput: {
        height: 2,
        // fontFamily: 'Muli',
        // fontSize: 15,
        // lineHeight: 19,
        // color: '#000000'
    },
    focused: {
        border: '2px solid #3f51b5'
    },
    text: {
        marginTop: -7
    }
};
function StyledInput(props) {
    return (
        <>
            <TextField
                id="outlined-basic"
                label={props.label ? props.label : ""}
                variant={props.variant ? props.variant : "outlined"}
                InputProps={{
                    classes: {
                        input: props.classes.searchInput,
                        // focused: props.classes.focused
                    }
                }}
                InputLabelProps={{
                    classes: { root: props.classes.text }
                }}
                value={props.value}
                onChange={props.handleChange}
                focused={props.focused ? true : false}
                multiline={props.multiline ? true : false}
                fullWidth={props.fullWidth ? true : false}
                className={props.className}
                {...props}
            />
        </>
    );
}

const MInput = withStyles(newStyles)(StyledInput);

// export default MInput;

export {
    CustomInput, CustomTextField, CustomInputLabel, CustomAdornmentInput, MInput
};
